module.exports = () => {
  const NODE_ENV = process.env.NODE_ENV; // eslint-disable-line prefer-destructuring
  const version = process.env.NEXT_PUBLIC_VERSION ?? '0.0.0';
  const packageName = process.env.NEXT_PUBLIC_PACKAGE_NAME;
  const name = NODE_ENV === 'production' ? `${packageName}@${version}` : undefined;
  return { name, version };
};
